import { render, staticRenderFns } from "./toast-text-only.mpx?vue&type=template&id=4628a80c&isComponent&outputPath=components%2Ftoast-text-only85ab43ae%2Findex"
import script from "./toast-text-only.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftoast-text-only85ab43ae%2Findex"
export * from "./toast-text-only.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftoast-text-only85ab43ae%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports